import braze from "appboy-web-sdk";
import env from "@irati/utils/env";
import authentication from "@irati/auth";
import { E2E } from "@irati/utils/constants/environment";
import { getBrazeKey, baseUrl } from "./env";
var setIdentity = function () {
    if (shouldUseBraze()) {
        setup();
        var user = authentication.user();
        braze.changeUser(user.uuid);
        braze.openSession();
    }
};
var clearIdentity = function () {
    if (shouldUseBraze()) {
        try {
            braze.destroy();
        }
        catch (err) { /* no-op */ }
    }
};
var setup = function () {
    if (shouldUseBraze()) {
        braze.initialize(getBrazeKey(), { baseUrl: baseUrl });
    }
};
var showLogging = function () {
    if (shouldUseBraze()) {
        braze.toggleAppboyLogging();
    }
};
export default {
    setup: setup,
    setIdentity: setIdentity,
    clearIdentity: clearIdentity,
    showLogging: showLogging
};
var shouldUseBraze = function () {
    var isRunningUnitTests = __IS_TEST__;
    var isE2E = env.ENVIRONMENT_NAME === E2E;
    // We don't want to run Braze if any of the variables above are true. Thanks Mr De Morgan
    return !(isRunningUnitTests || isE2E);
};
